import React from 'react';
import { Block } from '@uncinc/react-drupal-core';

import { APP_OPTIONS } from '../../../../config/constants';

const RiskMonitorCalculatorBlock = () => (
  <Block
    id={APP_OPTIONS.riskMonitorCalculatorBlockId}
    minimal
  />
);

export default RiskMonitorCalculatorBlock;
